import { mergeWith } from 'lodash';
import { replaceEqualDeep } from '@tanstack/react-query';

/**
 * Structural sharing for the observation being scouted.
 *
 * A fetch that lands while the page is open is merged over what is already
 * cached rather than replacing it, so a response that omits something does not
 * blank it out on the form. Rosters are the exception: they are taken from the
 * response whole, because merging them position by position would leave the
 * tail of a roster that has since been shortened sitting behind the new one.
 *
 * The result is run through react-query's own comparison so an unchanged
 * observation keeps its identity — that is what stops the form resetting under
 * the scout after every autosave.
 */
export const mergeObservation = (prevData: unknown, data: unknown) =>
  replaceEqualDeep(
    prevData,
    mergeWith({}, prevData, data, (_objValue, srcValue) =>
      Array.isArray(srcValue) ? srcValue : undefined
    )
  );
